/** Returns a copy of the nodes array without nodes that are contained in other nodes */
export function filterOutChildNodes<T extends Node>(nodes: Array<T>): Array<T> {
  return nodes.filter((node) => {
    return nodes.every((parent) => {
      return parent === node || parent.contains(node) === false
    })
  })
}

export function selectorMatcher(selector: string) {
  const body: any = document.body
  const matches =
    body.matches ||
    body.matchesSelector ||
    body.webkitMatchesSelector ||
    body.mozMatchesSelector ||
    body.msMatchesSelector

  return (node: Node) => {
    if (!(node instanceof Element)) {
      return false
    }
    return matches.call(node, selector)
  }
}

export function findClosestNode(
  firstNode: Node,
  match: (node: Node) => boolean
): Node | undefined | null {
  let node: Node | null = firstNode
  do {
    if (match(node)) return node
    node = node.parentNode
  } while (node)
  return null
}
